export const FETCH_SITE_CONF_IN_PROGRESS = 'FETCH_SITE_CONF_IN_PROGRESS'
export const FETCH_SITE_CONF_SUCCESS = 'FETCH_SITE_CONF_SUCCESS'
export const FETCH_SITE_CONF_FAILED = 'FETCH_SITE_CONF_FAILED'
export const SEARCH_IN_PROGRESS = 'SEARCH_IN_PROGRESS'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_FAILED = 'SEARCH_FAILED'
